import { Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity } from '@40seas/models';
import { z } from 'zod';

export const UserNotificationSettingsSchema = z
    .object({
        email: z.string().min(1),
        disabledEvents: z.array(z.string()),
        buyer: z.string().optional(),
    })
    .strict();

export class UserNotificationSettings extends FromSchema(UserNotificationSettingsSchema) implements BaseEntity {
    id: string;
    email: string;
    disabledEvents: string[];
    buyer?: string;

    tenantId: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    timeline?: { [status: string]: { updatedAt: Date } };
    metadata?: { [key: string]: string };
}
